import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
// SERVICES
import { AuthenticationConfigurationService } from '@services/authentication/authentication-configuration.service';
import { UserConfigurationService } from '@services/user/user-configuration.service';
// MODELS
import { Permission } from '@models/permission/Permission';
// CONSTS
import { PERMISSION } from './PERMISSION';
import { Router } from '@angular/router';
export const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
// TODO : TAG GTM
declare var dataLayer: any;
@Component({
  selector: 'ui-menu',
  templateUrl: './menu.html',
  styleUrls: ['./menu.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('indicatorSlide', [
      state('collapsed, void', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed, void => collapsed',
        animate(EXPANSION_PANEL_ANIMATION_TIMING)
      ),
    ]),
    trigger('slide', [
      state(
        'collapsed, void',
        style({ height: '0px', visibility: 'hidden', overflow: 'hidden' })
      ),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition(
        'expanded <=> collapsed, void => collapsed',
        animate(EXPANSION_PANEL_ANIMATION_TIMING)
      ),
    ]),
  ],
  host: { class: 'ui-menu' },
})
export class UIMenu implements OnInit, OnDestroy {
  subscription = new Subscription();
  items: Permission[] = [];
  rol = '';
  showOption?: boolean;
  cct: string | null = '';
  typeSchool: string | null = '';
  constructor(
    private userConfigurationService: UserConfigurationService,
    private router: Router,
    private authConfigService: AuthenticationConfigurationService
  ) {
    this.loadMenu();
  }

  ngOnInit() {
    this.cct = localStorage.getItem('cct');
    this.typeSchool = localStorage.getItem('typeSchool');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getUser() {
    this.subscription.add(
      this.authConfigService.currentUser.subscribe((x) => {
        this.rol = x?.rol || '';
      })
    );
  }

  loadMenu() {
    const email = sessionStorage.getItem('email');
    const systemId: number = Number(sessionStorage.getItem('systemId'));
    const role = Number(sessionStorage.getItem('role'));
    // this.showOption =  ? true : false;
    this.subscription.add(
      this.userConfigurationService.permissions.subscribe((x) => {
        // this.items = [...PERMISSION]
        let idsDeseados: number[] = [];
        if (systemId === 3) {
          idsDeseados = [248, 262, 250, 271];
        } else if (systemId === 2) {
          idsDeseados = [120, 241, 271];
        }
        let menu = x;
        if (email === 'usuarioprueba@hachette.com.mx'|| email === 'trayectorias@mail.com') {
          debugger;
          // Filtrar elementos con los IDs deseados
          menu = x.filter((item) => idsDeseados.includes(item.id));
          // const itemToRemove = x.findIndex(m => m.title === 'Novedades');
          // if (itemToRemove >= 0) {
          // 	x.splice(itemToRemove, 1);
          // }
        }
        if (email !== 'usuarioprueba@hachette.com.mx' && menu.find((m) => m.id === 271)) {
          const itemToRemove = menu.findIndex((m) => m.title === 'Novedades');
          if (itemToRemove >= 0) {
            menu.splice(itemToRemove, 1);
          }
        }

        if (role !== 98) {
          menu = menu.filter((item) => item.id !== 256);
        }
        this.items = menu;
      })
    );
  }

  toggle(item: HTMLElement, itemMenu: Permission, url: string) {
    this.eventGTM(itemMenu.title);

    const classToggle = 'list-group--open';
    item.classList.toggle(classToggle);

    const currentHost = window.location.host;
    if (this.isUrlValid(url)) {
      const urlHost = new URL(url).host;

      if (urlHost !== currentHost) {
        window.open(url, '_blank');
      }
    }
  }

  getExpandedState(item: HTMLElement) {
    const classToggle = 'list-group--open';
    return item.classList.contains(classToggle) ? 'expanded' : 'collapsed';
  }

  navigateTo(item: Permission) {
    // if (!item.children?.length) {
    //   this.eventGTM(item);
    //   this.router.navigate([item.url]);
    // }
  }

  eventGTM(title: string | undefined) {
    console.log('aqui hace click');

    console.log(title);
    sessionStorage.setItem('menu_select', JSON.stringify(title));
    dataLayer.push({
      event: 'menu_primary_click',
      account_type: this.rol,
      content_group: 'Menu',
      menu: title,
      cct: this.cct, //Dynamic data
      school_type: this.typeSchool,
    });
  }

  isUrlValid(str: string) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i'
    );
    return pattern.test(str);
  }
}
